/* eslint-disable */

export class VCCArticle {
  constructor(supportSite) {
    this.supportSite = supportSite;
    this.vccsupport  = this.supportSite.vccsupport;
    
    const langDict = window.LANG_STRINGS || {};
    
    // Set default values used by VCC scripts
    langDict.showSearchBox = false;
    langDict.isRTL         = false;
    langDict.pageLayout    = "SupportArticle";
    langDict.version       = "1";
    
    this.vccsupport.init(langDict);
    
    this.init();
  }
  
  init() {
    const Setup = new SupportArticle(this.vccsupport);
    
    Setup.setnumberslist();
    Setup.positionelements();
    Setup.createinformationlayer();
    Setup.styletables();
    Setup.setReusableText();
    Setup.setarrowsinmenupath();
    Setup.adaptortl();
    Setup.setupimages();
    Setup.fixTables();
    Setup.fixLinks();
    Setup.fixProcedures();
    
    /* mobile */
    if (vcc.isMobileViewport) {
      Setup.showonlyfourrelatedarticles();
      Setup.setupvideos();
      // Setup.videoformobile();
      Setup.makeRelatedContentFoldable();
    }
    else {
      Setup.setupvideos();
      Setup.pushlastfigureright();
    }
    
    if (this.vccsupport.ie6) {
      Setup.adaptlistnumbersforie6();
    }
    
    Setup.fixContentHeight();
    
    // this.vccsupport.showRateThisPage();
  }
  
}

class SupportArticle {
  constructor(vccsupport) {
    this.noteText    = "";
    this.warningText = "";
    this.cautionText = "";
    this.domobj      = "";
    this.vccsupport  = vccsupport;
  }
  
  displayWidthOnPage() {
    setInterval(function() {
      var w = $("#articlepagecontent").width();
      $("#width").text("width = " + w + "px");
    }, 2000);
  }
  
  styletables() {
    $(".table tr:odd").css('background-color', '#f4f4f4');
    
    $(".table").each(function() {
      if ($(this).children().first()[0].tagName === "THEAD") {
        $("td", this)
          //.css('text-align', 'center')
          // .css('padding', '5px 0');
      }
    });
    
  }
  
  fixLinks() {
    $("#articlepagecontent a").each(function(i) {
      // Make external links open in new tab
      var aLink   = $(this).attr("href");
      // Parse the link by creating a <a> and then checking the hostname of that <a>
      var parser  = document.createElement('a');
      parser.href = aLink;
      if (parser.hostname && parser.hostname.length > 0 && parser.hostname != window.location.hostname) {
        if (!$(this).attr("target"))
          $(this).attr("target", "_blank");
      }
    })
  }
  
  fixProcedures() {
    $(".article-content .procedure.style-number .step:only-child").each(function(i) {
      $(this).find(".stepnumber").html("-");
    });
    // Fix position of non integer step numbers
    $(".procedure.style-number").each(function() {
      var self = $(this), sn = self.find(".stepnumber"), top = 9;
      if (self.prevAll(".p_img_text").length > 0) {
        top = 5;
      }
      sn.each(function() {
        var me = $(this), text = me.text();
        if (text && text.length) {
          if (!parseInt(text, 10)) {
            me.css("top", top);
          }
        }
      });
    });
  }
  
  fixTables() {
    var self         = this;
    var updateTables = function() {
      var articleElem = $("#articlevoicecontent"), articleTop, articleWidth, relatedContentH;
      if (articleElem.length === 1) {
        articleTop      = articleElem.offset().top;
        articleWidth    = articleElem.width();
        relatedContentH = $("#related-content").height();
        articleElem.find("table").each(function(i, element) {
          var tableTop              = $(this).offset().top - articleTop - 30;
          var tableW                = $(this).width();
          var relatedContentOverlap = relatedContentH - tableTop;
          var tableTooWide          = (tableW >= articleWidth) || (!self.vccsupport.isDesktopMode() && tableW > 420);
          if (!$(this).hasClass("responsive")) {
            if ($(window).width() < 670 && tableTooWide || (self.vccsupport.isDesktopMode() && relatedContentOverlap > 0 && tableW > 644)) { // If mobile or if the table is high up on the page and overlaps related-content in the right column
              $(this).addClass("responsive");
              $(this).wrap("<div class='table-wrapper' />");
            }
          }
        });
        if (vcc.isMobileViewport)
          $(".table-wrapper").css({width: $(window).width() - 40, maxWidth: 380});
      }
    };
    
    $(window).on("load", updateTables);
    $(window).bind("resize", updateTables);
  }
  
  setarrowsinmenupath() {
    $(".menupath .display-db").each(function() {
      if (!$(this).is(':last-child')) {
        $(this).append("<span class=\"arrow\"></span>");
      }
    });
  }
  
  setnumberslist() {
    $(".style-number").each(function() {
      var i = 0;
      var currenthtml;
      $(".step", this).each(function() {
        i++;
        currenthtml = this.innerHTML;
        $(this).empty();
        $(this).append("<div class=\"stepnumber\">" + i + "</div>");
        $(this).append(currenthtml);
        
        if ($(this).is(':last-child')) {
          $(this).addClass('last');
        }
      });
    });
  }
  
  playVideo(wrapperId, poster, src) {
    var videoId = wrapperId + "_video";
    var sHtml   = "<video id='" + videoId + "' width='644' height='363' class='video-js vjs-default-skin'></video>";
    $(poster).parent().append(sHtml);
    $(poster).hide();
    this.vccsupport.setUpVideo(videoId, src);
  }
  
  setupvideos() {
    
    var i   = 0;
    var rtl = 'left';
    
    if ($('body')[0].className == 'rtl') {
      rtl = 'right';
    }
    
    $(".segment .multimedia video").each(function() {
      $(this)
        .attr('controls', true)             // Simply add vidoe controls
        .attr('controlsList', 'nodownload') // Remove download button
    });
    
    $(".multimedia").each(function() {
      let $this = $(this);

      if ($this.parent().hasClass("validity positive")) {
        $this.parent().css("display", "inline");
      }
      $this.fadeIn();
    });
    
    if (this.vccsupport.ie6) {
      $(".video-overbox").height($(".video-overbox").parent().height());
    }
  }
  
  videoformobile() {
    var i = 0;
    $(".segment .multimedia video").each(function() {
      i++;
      var src    = this.src;
      var poster = $(this).parent().children(".video-thumbnail");
      $(this).parent().children(".video-thumbnail").remove();
      var container  = $("<div class=\"videocontainer_" + i + " mediacontainer\"><img src=\"" + poster[0].src + "\"/></div>");
      var html       = "<video width=\"" + $(this).parent().width() + "\" height=\"" + $(this).parent().height() + "\" controls><source src=\"" + src + "\"> Your browser does not support the video tag.</video>";
      var playbutton = "<div class=\"videoplaybutton\"></div>";
      
      $(this).parent().append(container);
      var header = $(this).parent().children("h4");
      if (header && header.html().length < 2)
        header.hide();
      $(header).insertAfter(container);
      $(".videocontainer_" + i, $(this).parent()).append(html);
      $(this).remove();
      $("video").hide();
      $(".videocontainer_" + i).append(playbutton);
      $(".videocontainer_" + i).click(function() {
        $("video", this).attr("width", $(this).width());
        $("video", this).attr("height", $(this).height());
        $("img", this).hide();
        $(".videoplaybutton", this).hide();
        $("video", this).show();
        $("video", this).get(0).play();
      });
      
      $(".multimedia").fadeIn("fast", function() {
        var Setup = supportarticle();
        
        $(".multimedia video").each(function() {
          //$(this).attr("height", $(this).parent().height());
        });
      });
    });
  }
  
  setupimages() {
    const self = this;
    
    // Fix <p> with invalid class "p.img"
    $(".article-content p").each(function() {
      if ($(this)[0].className == "p.img") {
        $(this).addClass("p_img");
      }
    });
    
    // Format p_img texts (Rule: If there is a <p> after the p.img, it should be displayed to the right of the img. THe img should be 100px)
    $(".p_img").each(function() {
      var $this = $(this);
      
      if ($this.is("p")) {
        var nextP = $this.next("p");
        if (nextP && !nextP.hasClass("p_img"))
          nextP.addClass("p_img_text");
      }
    });
    
    $(".figure img.pgwide-yes").each(function() {
      var thumbNailUrl = this.src.toLowerCase();
      var largeUrl     = thumbNailUrl.replace("_th.jpg", ".jpg");
      this.src         = largeUrl;
      
    });
  }
  
  positionelements() {
    var appliesToSection = $(".applies-to"),
        listedCategories = $("#listed-categories");
    
    if (appliesToSection.length > 0) {
      listedCategories.appendTo(appliesToSection);
    }
    else {
      if (vcc.isMobileViewport) {
        listedCategories.removeClass("related-info-inner");
        listedCategories.appendTo(".article-content");
        listedCategories.css({
          "border-top" : "1px solid #e7e8e9",
          "padding-top": "10px",
          "float"      : "left",
          "width"      : "100%"
        });
      }
    }
    
    if (vcc.isMobileViewport) {
      $("#ratethispage").insertAfter($("#related-content"));
    }
  }
  
  makeRelatedContentFoldable() {
    $("#related-content .related-info-header").click(function() {
      var relatedInfo = $(this).nextAll(".related-info-inner");
      if (relatedInfo.is(":visible")) {
        relatedInfo.slideUp('fast');
        $(this).removeClass('expanded');
      }
      else {
        relatedInfo.slideDown('fast');
        $(this).addClass('expanded');
      }
    });
  }
  
  createinformationlayer() {
    var self = this;
    $(".fn_p").each(function() {
      var $this = $(this);
      
      if ($this.html().length == 0) {
        $this.hide();
        return;
      }
      
      var layerContent = $this.html();
      $this.html("");
      $this.click(function() {
        self.note(layerContent, $(this));
      });
    });

    var optionTags = $(".option");
    var optionTagText = self.vccsupport.resources.get("TopicOptionTagText");

    optionTags.each(function() {
      var $this = $(this);
      
      var layerContent = $this.html();
      // $this.html("");
      $this.click(function() {
        self.note(optionTagText, $(this));
      });

      var article = $this.closest('.article-ref');
      var footNotes = $('.topic-footnotes', article);
      if(footNotes.length === 0) {
        $('.article-content', article).parent()
          .append(`<div class="topic-footnotes">
                     <ul>
                       <li class="fn-item option-item"><sup>*</sup>${optionTagText}</li>
                     </ul>
                   </div>`)
      }
      else if($('.option-item', footNotes).length === 0) {
        $('ul', footNotes).append(`<li class="fn-item option-item"><sup>*</sup>${optionTagText}</li>`)
      }
    });
    
    /*
    $("span.option").each(function () {
        $this = $(this);

        if ($this.parent("a").length > 0) {
            $this.removeClass("option");
        }
        else {
            $this.html("");

            // TODO: Retrieve correct information to show in the popupbox

            $this.click(function () {
                supportarticle().note("", $(this), true);
            });
        }
    });*/
  }
  
  note(popupHtml, noteLink, isOptionPopup) {
    var popup = $(".notecontent");
    var articleContainer = $('.topic-article');

    if (popup.length == 0) {
      popup = $("<div class='notecontent'></div>");
      popup.appendTo(articleContainer);
      
      $("<div class='note-closebutton' />").click(function() {
        $(this).parent().hide();
      }).prependTo(popup);
      
      if (isOptionPopup && isOptionPopup == true)
        $("<div class='note-icon option' />").prependTo(popup);
      else
        $("<div class='note-icon' />").prependTo(popup);
      $("<div class='note-content' >" + popupHtml + " </div>").appendTo(popup)
    }
    else {
      popup.find(".note-content").html(popupHtml);
      if (isOptionPopup && isOptionPopup == true)
        popup.find(".note-icon").addClass("option");
      else
        popup.find(".note-icon").removeClass("option");
    }
    
    var win  = $(window);
    var left = vcc.isMobileViewport ? 0 : articleContainer.width() - popup.width() / 2;
    
    if (!vcc.isMobileViewport && this.vccsupport.pagelayout == "CarQuickGuide") {
      if (noteLink.offset().left > (win.width() / 2) && noteLink.parents(".article-lead").length == 0) {
        left += 329;
      }
    }
    
    var parentOffset = articleContainer.offset().top;
    
    if (this.vccsupport.isRTL) {
      popup.css({
        display: 'block',
        top    : noteLink.offset().top + -parentOffset + 'px',
      });
    }
    else {
      popup.css({
        display: 'block',
        top    : noteLink.offset().top + -parentOffset + 'px',
      });
    }
    
    win.resize(function() {
      popup.hide();
    });
    
    popup.click(function() {
      $(this).hide();
    });
  }
  
  showonlyfourrelatedarticles() {
    if ($(".relatedarticlelink").length > 4) {
      $(".relatedarticlelink").slice(4).hide();
      $(".seemorearticles").appendTo(".relatedarticles");
      $(".seemorearticles").show();
      
      var contentwidth = ($(".seemorearticlestext").parent().width() / 2 - 14 - ($(".seemorearticlestext").width() / 2));
      
      if (this.vccsupport.isRTL) {
        $(".seemorearticlestext").css({
          'margin-right': contentwidth + "px"
        });
      }
      else {
        $(".seemorearticlestext").css({
          'margin-left': contentwidth + "px"
        });
      }
      
      $(".seemorearticles").click(function() {
        $(".seemorearticles").hide();
        $(".relatedarticlelink").fadeIn('fast');
      });
    }
    else {
      $(".seemorearticles").hide();
    }
  }
  
  setReusableText() {
    const self = this;
    
    if ($(".special_texts").length > 0)
      return;
    $(".warning").each(function() {
      $(this).prepend("<h2>" + self.vccsupport.resources.get("TopicheaderTextWarning") + "</h2>");
    });
    $(".caution, .important").each(function() {
      $(this).prepend("<h2>" + self.vccsupport.resources.get("TopicheaderTextCaution") + "</h2>");
    });
    $(".note").each(function() {
      $(this).prepend("<h2>" + self.vccsupport.resources.get("TopicheaderTextNote") + "</h2>");
    });
  }
  
  pushlastfigureright() {
    const self = this;
    
    $(".figure").each(function() {
      var $this = $(this);
      if ($this.prev().hasClass("figure")) {
        var figureImg = $this.find("img");
        if (figureImg.length > 0 && figureImg.hasClass("web-pagewide"))
          return;
        
        if ($this.prev().css("float") == "none") {
          $this.prev().css("float", self.vccsupport.isRTL ? "right" : "left");
          $this.css("float", self.vccsupport.isRTL ? "left" : "right");
        }
        else if ($this.prev().css("float") == "left") {
          $this.css("float", "right");
        }
        else {
          $this.css("float", "left");
        }
        
        var newWidth = (($this.parent().is(":visible") ? $this.parent().width() : $("#articlevoicecontent").width()) - 10) / 2;
        $this.width(newWidth);
        $this.prev().width(newWidth);
        
      }
    }).fadeIn('fast');
    
  }
  
  adaptortl() {
    if ($('body').hasClass("rtl")) {
      $(".applies-to").removeClass('applies-to').addClass('applies-to-rtl');
    }
  }
  
  adaptlistnumbersforie6() {
    $(".stepnumber").each(function() {
      $(this).removeClass("stepnumber").addClass("stepnumber");
    });
  }
  
  fixContentHeight() {
    var newHeight = this.vccsupport.isRTL ? $(".applies-to-rtl").height() + $(".socialcontainer").height() :
      $(".applies-to").height() + $(".socialcontainer").height();
    var content   = $("#content-inner");
    if (content.height() < newHeight)
      content.height(newHeight + "px");
  }
}